import { render, staticRenderFns } from "./XIcon.vue?vue&type=template&id=4b52bc5c&scoped=true&"
import script from "./XIcon.vue?vue&type=script&lang=js&"
export * from "./XIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52bc5c",
  null
  
)

export default component.exports